import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SpeedDial from '@mui/material/SpeedDial';
import { SpeedDialAction } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PermDeviceInformationIcon from '@mui/icons-material/PermDeviceInformation';
import PrintIcon from '@mui/icons-material/Print';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  DEVICES_ARCHIVE_ROUTE,
  DEVICES_CHART_ROUTE,
  DEVICES_INFO_ROUTE,
  DEVICES_SETUP_ROUTE,
  MAIN_ROUTE,
} from '../../constant/routes';
import i18n from '../../localization/Localization';

const actions = [
  {
    icon: <HomeIcon sx={{ color: '#9c27b0' }} />,
    name: 'Главная',
    tooltip: i18n.t('tooltipMain'),
  },
  {
    icon: <PermDeviceInformationIcon sx={{ color: '#29b6f6' }} />,
    name: 'Информация',
    tooltip: i18n.t('tooltipInfo'),
  },
  {
    icon: <PrintIcon sx={{ color: '#ef5350' }} />,
    name: 'Отчет',
    tooltip: i18n.t('tooltipPrint'),
  },
  {
    icon: <ShowChartIcon sx={{ color: '#26a69a' }} />,
    name: 'График',
    tooltip: i18n.t('tooltipChart'),
  },
  {
    icon: <SettingsIcon sx={{ color: '#ff7043' }} />,
    name: 'Настройки',
    tooltip: i18n.t('tooltipSetup'),
  },
];

export const SpeedDiaFlowmeterlDiv = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = (name: string) => {
    if (name === 'Главная') {
      navigate(`${MAIN_ROUTE}`);
    }
    if (name === 'Информация') {
      navigate(`${DEVICES_INFO_ROUTE}/${id}`);
    }
    if (name === 'Отчет') {
      navigate(`${DEVICES_ARCHIVE_ROUTE}/${id}`);
    }
    if (name === 'График') {
      navigate(`${DEVICES_CHART_ROUTE}/${id}`);
    }
    if (name === 'Настройки') {
      navigate(`${DEVICES_SETUP_ROUTE}/${id}`);
    }
    setOpen(false);
  };

  return (
    <div>
      <SpeedDial
        ariaLabel=""
        sx={{
          '& .MuiFab-primary': {
            backgroundColor: 'var(--app-section-background)',
            width: 5,
            height: 5,
            visibility: 'hidden',
          },
        }}
        direction="right"
        icon={<SpeedDialIcon openIcon={<MoreVertIcon />} />}
        onClick={handleOpen}
        open={open}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            sx={{ marginRight: action.name === 'Главная' ? '25px' : undefined }}
            tooltipTitle={action.tooltip}
            icon={action.icon}
            onClick={() => handleClose(action.name)}
          />
        ))}
      </SpeedDial>
    </div>
  );
};
